// eBay localisation URL helper.
//
// Extracted from ItemView so that lightweight consumers (e.g. RecentlyViewed)
// can use `processUrl` without statically importing the heavy ItemView page
// (which bundles the image carousel, zoom/pan and DOMPurify). This keeps
// ItemView in its own lazily-loaded chunk.
export function processUrl(domain, url) {
    let output;
    if (domain) {
        output = getLocalEbay(domain, url);
    }
    return output;
}

export function getLocalEbay(domain, url) {
    if (domain === 'be') {
        domain = 'fr';
    }
    return url?.replace?.(/\..*\//, ".ebay." + domain + "/itm/");
}
